import {useState} from 'react';

import OptionsCard from '../OptionsCard/OptionsCard';

import styles from "./ShadowOptions.module.css"

export default function ShadowOptions(props) {
  return (
    <OptionsCard>
      <label htmlFor="shadow-enabled">Shadow</label>

      <select id="shadow-enabled" onInput={(e) => {props.setShadowEnabled(e.target.value)}}>
        <option value={"on"} selected={props.shadowEnabled === "on"}>On</option>
        <option value={"off"} selected={props.shadowEnabled === "off"}>Off</option>
      </select>

      <div className={`${styles.shadowCustomisations} ${props.shadowEnabled === "on" ? styles.visible : ""}`}>
        <label htmlFor=" color">Shadow Color</label>
        <input type="color" id="color" defaultValue={props.shadowColor} onInput={(e) => {props.setShadowColor(e.target.value); console.log(e.target.value)}} />

        <div>
          <div>
            <label htmlFor="x-offset">X Offset</label>
            <p><input type="number" id="x-offset" defaultValue={props.xOffset} onInput={(e) => {props.setXOffset(e.target.value)}} />px</p>
          </div>

          <div>
            <label htmlFor="y-offset">Y Offset</label>
            <p><input type="number" id="y-offset" defaultValue={props.yOffset} onInput={(e) => {props.setYOffset(e.target.value)}} />px</p>
          </div>

          <div>
            <label htmlFor="blur-radius">Blur Radius</label>
            <p><input type="number" id="blur-radius" defaultValue={props.blurRadius} min={0} max={500} onInput={(e) => {props.setBlurRadius(e.target.value)}} />px</p>
          </div>
        </div>

        <label htmlFor="shadow-opacity">Opacity</label>
        {/* <input type="range" id="shadow-opacity" step={10} min={10} max={90} defaultValue={props.shadowOpacity} onInput={(e) => {props.setShadowOpacity(e.target.value)}} /> */}
        <input type="number" id="shadow-opacity" min={1} max={100} defaultValue={props.shadowOpacity} onInput={(e) => {props.setShadowOpacity(e.target.value)}} />
      </div>
    </OptionsCard>
  );
}
